import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { styles } from './empty-tbr-action-window-styles';

const EmptyTBRActionWindow = (): JSX.Element => {
  const { t } = useTranslation();
  const classes = styles();

  return (
    <>
      <Grid item className={classes.alignEnd}>
        <Typography variant='h4' data-testid='empty-action-window-tbr-title'>
          {t('ActionWindow_Empty_TBRTitle')}
        </Typography>
      </Grid>
    </>
  );
};

export default EmptyTBRActionWindow;
